export const cleanseValue = (input) => typeof input !== 'string'
  ? input
  : input
    .replace(/&nbsp;/g, '')
    .replace(/[\u200B-\u200D\uFEFF]/g, '')
    .trim()
